// @ts-strict-ignore
import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';

type StickyPlaceholderJsxProps = {
  props: {
    stickyElm: HTMLElement;
  };
};

export class StickyPlaceholder extends Component<EmptyObj> {
  private stickyObserver: IntersectionObserver = null;
  private _stickyElm: HTMLElement = null;

  get config() {
    return {
      template,
      helpers: {
        onInsertStickyPlaceholder: ({elm}) => {
          if (this.stickyObserver) {
            this.stickyObserver.disconnect();
          }

          this.stickyObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (
                  !entry.isIntersecting &&
                  entry.target.getBoundingClientRect().top < this.stickyElm?.getBoundingClientRect().top
                ) {
                  this.stickyElm?.classList.toggle(`stuck`, true);
                } else {
                  this.stickyElm?.classList.toggle(`stuck`, false);
                }
              });
            },
            {
              root: null,
              threshold: 0.1,
            },
          );
          this.stickyObserver.observe(elm);
        },
      },
    };
  }

  set stickyElm(value: HTMLElement) {
    this._stickyElm = value;
  }

  get stickyElm() {
    return this._stickyElm;
  }
}

export const StickyPlaceholderEl = defineAndMakeJsxFactory<StickyPlaceholderJsxProps>(
  `sticky-placeholder`,
  StickyPlaceholder,
);
export const StickyPlaceholderReact = panel2react<StickyPlaceholderJsxProps>(`sticky-placeholder`, StickyPlaceholder);
